module.exports = __webpack_public_path__ + "media/Schastye_1980х1100.c39e68b6.mp4";